/** Top-level fields whose values differ between two snapshots of a record
 *  (JSON-level compare) — feed the result to ConflictBanner's `changedFields`
 *  so a 409 names what actually drifted. Bookkeeping fields are ignored by
 *  default. */
export function diffFieldNames(
  base: Record<string, unknown>,
  server: Record<string, unknown>,
  ignore: readonly string[] = ['updated_ts', 'created_ts'],
): string[] {
  const keys = new Set([...Object.keys(base), ...Object.keys(server)]);
  const out: string[] = [];
  for (const k of keys) {
    if (ignore.includes(k)) continue;
    if (JSON.stringify(base[k]) !== JSON.stringify(server[k])) out.push(k);
  }
  return out.sort();
}
